const ANYDESK_ID_KEYS = ["anydeskCode", "anydeskId", "anydesk_id", "code"];
const ANYDESK_PASSWORD_KEYS = ["anydeskPassword", "password", "anydesk_password"];

const hasFieldValue = (value) => value != null && String(value).trim() !== "";

export const hasAnydeskFields = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  return ANYDESK_ID_KEYS.some((key) => hasFieldValue(value[key])) ||
    ANYDESK_PASSWORD_KEYS.some((key) => hasFieldValue(value[key]));
};

export const getAnydeskIdFromRecord = (anydesk) => {
  for (const key of ANYDESK_ID_KEYS) {
    const value = anydesk?.[key];
    if (hasFieldValue(value)) {
      return value;
    }
  }

  return "";
};

export const getAnydeskPasswordFromRecord = (anydesk) => {
  for (const key of ANYDESK_PASSWORD_KEYS) {
    const value = anydesk?.[key];
    if (hasFieldValue(value)) {
      return String(value);
    }
  }

  return "";
};

export const getAnydeskFromResponse = (response) => {
  if (response == null || typeof response !== "object") {
    return null;
  }

  if (Array.isArray(response)) {
    const record = response.find(hasAnydeskFields) || response[0];
    return record && hasAnydeskFields(record) ? record : null;
  }

  if (hasAnydeskFields(response)) {
    return response;
  }

  const candidates = [
    response?.anydesk,
    response?.data?.anydesk,
    response?.response?.anydesk,
    response?.data,
    response?.response,
    response?.result,
    response?.record,
    ...(Array.isArray(response?.anydesks) ? [response.anydesks] : []),
    ...(Array.isArray(response?.data?.anydesks) ? [response.data.anydesks] : []),
    ...(Array.isArray(response?.response?.anydesks) ? [response.response.anydesks] : []),
    ...(Array.isArray(response?.records) ? [response.records] : [])
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      const record = candidate.find(hasAnydeskFields) || candidate[0];
      if (record && hasAnydeskFields(record)) {
        return record;
      }
      continue;
    }

    if (hasAnydeskFields(candidate)) {
      return candidate;
    }
  }

  return null;
};

export const formatAnydeskCode = (value) => String(value ?? "").replace(/\D/g, "");
